import mercuryCharger from "../assets/images/deviceImages/mercury_charger.png";
import {
  deviceDefaultMaterials,
  deviceGroupNames,
  deviceGroups,
  deviceKitName,
  deviceKitNameExtended,
  deviceKitNameType,
  deviceKitNameTypeExtended,
  deviceTypes,
  deviceTypesConfig,
  mercuryDevices,
  strCode
} from "../consts";

const getDeviceOptions = (extendedDeviceNames) => {
  const deviceNames = extendedDeviceNames ? deviceKitNameExtended : deviceKitName;

  return [
    { id: 0, value: strCode.ALL_DEVICES_LABEL },
    ...Object.keys(deviceNames).map((device, index) => {
      return { id: index + 1, value: deviceNames[device] };
    })
  ];
};

const getDeviceTypesByName = (deviceName, extendedDeviceNames) => {
  let deviceTypes = [deviceKitNameType.DEV_TYPE_KIT];

  if (extendedDeviceNames) {
    deviceTypes.push(
      ...Object.keys(deviceKitNameTypeExtended).filter(
        (key) => deviceKitNameTypeExtended[key] === deviceName
      )
    );
  } else {
    deviceTypes.push(
      ...Object.keys(deviceKitNameType).filter((key) => deviceKitNameType[key] === deviceName)
    );
  }

  return deviceTypes;
};

const getDeviceNameByType = (deviceType, extendedDeviceNames) => {
  let deviceName = deviceType;

  if (extendedDeviceNames) {
    deviceName = deviceKitNameTypeExtended[deviceType];
  }

  return deviceName;
};

const getDeviceModelNameByType = (deviceType) => {
  const deviceName = deviceKitNameType[deviceType];

  return deviceName;
};

const getDeviceGroup = (deviceType) => {
  let deviceGroup;

  Object.keys(deviceGroups).forEach((group) => {
    if (deviceGroups[group].includes(deviceType)) {
      deviceGroup = group;
      return;
    }
  });

  return deviceGroup;
};

const getDeviceGroupByName = (deviceName) => {
  let deviceGroup;

  const deviceTypes = getDeviceTypesByName(deviceName);

  if (deviceTypes && deviceTypes[1]) {
    Object.keys(deviceGroups).forEach((group) => {
      if (deviceGroups[group].includes(deviceTypes[1])) {
        deviceGroup = group;
        return;
      }
    });

    if (["chargers", "holders"].includes(deviceGroup)) {
      deviceGroup = "duoDevices";
    }
  }

  return deviceGroup;
};

const parseDusn = (serialNumber) => {
  const getParsedCodeFromSerialNumber = (start, end) => {
    return parseInt(serialNumber.substring(start, end), 16);
  };

  const platformId = getParsedCodeFromSerialNumber(2, 6);
  const productId = getParsedCodeFromSerialNumber(6, 10);
  const serialNumberStart = getParsedCodeFromSerialNumber(14, 15);

  return { platformId, productId, serialNumberStart };
};

const getDeviceTypeBySerialNumber = (serialNumber) => {
  if (!serialNumber) {
    return false;
  }

  const { platformId, productId, serialNumberStart } = parseDusn(serialNumber);

  if (
    (productId === 0x0034 && platformId === 0x001a) ||
    (productId === 0x0038 && platformId === 0x001e)
  ) {
    return deviceTypes.DEV_TYPE_V24_CHARGER;
  } else if (productId === 0x0033 && platformId === 0x0018) {
    return deviceTypes.DEV_TYPE_V24_HOLDER;
  } else if (
    (productId === 0x0043 && platformId === 0x0023) ||
    (productId === 0x0045 && platformId === 0x0024) ||
    (productId === 0x0045 && platformId === 0x0029) ||
    (productId === 0x004c && platformId === 0x002e)
  ) {
    return deviceTypes.DEV_TYPE_V24P_CHARGER;
  } else if (productId === 0x0044 && platformId === 0x0018) {
    return deviceTypes.DEV_TYPE_V24P_HOLDER;
  } else if (productId === 0x0047 && platformId === 0x0028) {
    return deviceTypes.DEV_TYPE_P1V30_CHARGER;
  } else if (productId === 0x0048 && platformId === 0x0027) {
    if (serialNumberStart === 0xc || serialNumberStart === 0x4) {
      return deviceTypes.DEV_TYPE_P1V31_HOLDER;
    } else {
      return deviceTypes.DEV_TYPE_P1V30_HOLDER;
    }
  } else if (productId === 0x0049 && platformId === 0x002d) {
    return deviceTypes.DEV_TYPE_P1V30M;
  } else if (productId === 0x005e && platformId === 0x0036) {
    return deviceTypes.DEV_TYPE_P1V31M;
  } else if (
    ((productId === 0x0053 || productId === 0x0060) && platformId === 0x0028) ||
    ((productId === 0x0061 || productId === 0x0062) && platformId === 0x0037)
  ) {
    return deviceTypes.DEV_TYPE_P1V31_CHARGER;
  } else if (
    (productId === 0x0041 && platformId === 0x0021) ||
    (productId === 0x004a && platformId === 0x002b)
  ) {
    return deviceTypes.DEV_TYPE_P4_M3_G1;
  } else if (productId === 0x0052 && platformId === 0x002f) {
    return deviceTypes.DEV_TYPE_P4_M3_G2;
  } else if (productId === 0x004f && platformId === 0x0030) {
    return deviceTypes.DEV_TYPE_P1_ARIANE;
  } else if (productId === 0x0057 && platformId === 0x0033) {
    return deviceTypes.DEV_TYPE_P1V40V_CHARGER;
  } else if (productId === 0x0055 && platformId === 0x0032) {
    return deviceTypes.DEV_TYPE_P1V40V_HOLDER_CONTROL;
  } else if (productId === 0x005a && platformId === 0x0033) {
    return deviceTypes.DEV_TYPE_P1V40C_CHARGER;
  } else if (
    [0x0058, 0x0059, 0x005f, 0x006f].includes(productId) &&
    [0x0029, 0x0038].includes(platformId)
  ) {
    return deviceTypes.DEV_TYPE_P1V40C_HOLDER_CONTROL;
  } else if (
    [0x005c, 0x005b, 0x0064].includes(productId) &&
    [0x0034, 0x0029].includes(platformId)
  ) {
    return deviceTypes.DEV_TYPE_P1V40D_CONTROL;
  } else if (productId === 0x0069 && platformId === 0x0033) {
    return deviceTypes.DEV_TYPE_P1V41P_CHARGER;
  } else if (productId === 0x0066 && platformId === 0x0032) {
    return deviceTypes.DEV_TYPE_P1V41P_HOLDER_CONTROL;
  } else if (productId === 0x006a && platformId === 0x0033) {
    return deviceTypes.DEV_TYPE_P1V41M_CHARGER;
  } else if (productId === 0x0068 && platformId === 0x0034) {
    return deviceTypes.DEV_TYPE_P1V41J_CONTROL;
  } else if (productId === 0x0072 && platformId === 0x003a) {
    return deviceTypes.DEV_TYPE_P1V41A_CONTROL;
  } else if (platformId === 0x0039 && productId === 0x0066) {
    return deviceTypes.DEV_TYPE_P1V41_HOLDER_CONTROL;
  } else if (platformId === 0x0033 && productId === 0x0066) {
    return deviceTypes.DEV_TYPE_P1V41P_CHARGER;
  } else if (platformId === 0x0029 && productId === 0x0063) {
    return deviceTypes.DEV_TYPE_P1V41_HOLDER_ENGINE;
  } else {
    return deviceTypes.DEV_TYPE_UNKNOWN;
  }
};

const validateMercuryDeviceDusn = (serialNumber) => {
  const { platformId, productId } = parseDusn(serialNumber);

  return (
    (productId === 0x0074 && platformId === 0x003c) ||
    (productId === 0x003c && platformId === 0x0074)
  );
};

const getDeviceDefaultMaterial = (deviceType) => {
  return deviceDefaultMaterials[deviceType];
};

const getDefaultMaterialByDeviceType = (type) => {
  const defaultMaterial = getDeviceDefaultMaterial(type);

  if (defaultMaterial) {
    const material = {
      materialGroup: defaultMaterial[0],
      materialBrandFamily: defaultMaterial[1],
      materialModelNumber: defaultMaterial[2],
      materialColor: defaultMaterial[3]
    };

    return material;
  }
};

const formatDeviceMaterial = (material) => {
  const { materialGroup, materialBrandFamily, materialModelNumber, materialColor } = material ?? {};

  if (materialGroup && materialBrandFamily && materialModelNumber && materialColor) {
    return `${materialGroup}_${materialBrandFamily}_${materialModelNumber}_${materialColor}`;
  }
};

const getDeviceImage = (material, deviceType) => {
  let deviceImage = formatDeviceMaterial(material);

  if (!deviceImage) {
    if (deviceType) {
      const defaultDeviceMaterial = getDefaultMaterialByDeviceType(deviceType);
      deviceImage = formatDeviceMaterial(defaultDeviceMaterial);
    }
  }

  if (!deviceImage) {
    deviceImage = "NO_IMG";
  }

  return deviceImage;
};

const getIsMercuryDevice = (deviceName) => {
  return Object.values(mercuryDevices).includes(deviceName);
};

const getDeviceType = (model) => {
  const isMercury = getIsMercuryDevice(model);
  if (isMercury) {
    return [deviceGroupNames.charger];
  }

  const type = deviceTypesConfig?.[deviceKitNameType?.[model]]?.[model];

  return type ?? [];
};

export const getDeviceImageAsset = async (imageName, isMercuryDevice) => {
  if (isMercuryDevice) {
    return mercuryCharger;
  }

  const img = imageName ? imageName : "NO_IMG";

  try {
    const { default: image } = await import(`../assets/images/devices/${img}.webp`);

    return image;
  } catch (e) {
    const { default: image } = await import(`../assets/images/devices/NO_IMG.webp`);

    return image;
  }
};

const getDeviceImageAssetByType = async (model, type) => {
  const isMercuryDevice = getIsMercuryDevice(model);
  let img = null;

  if (model && type && !isMercuryDevice) {
    const name = `IQOS ${(model + (type?.toUpperCase() !== "MONO" ? type : "")).toUpperCase()}`;

    const kit = Object.keys(deviceKitNameTypeExtended).find(
      (key) => deviceKitNameTypeExtended[key] === name
    );

    img = getDeviceImage(null, kit) ?? "NO_IMG";
  }

  return await getDeviceImageAsset(img, isMercuryDevice);
};

const deviceUtil = {
  getDeviceOptions,
  getDeviceTypesByName,
  getDeviceNameByType,
  getDeviceModelNameByType,
  getDeviceGroup,
  getDeviceGroupByName,
  getDeviceTypeBySerialNumber,
  validateMercuryDeviceDusn,
  getDeviceImage,
  getDeviceImageAsset,
  getDeviceImageAssetByType,
  getIsMercuryDevice,
  getDeviceType
};

export default deviceUtil;
